import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, OnDestroy, QueryList, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiNugetDeploymentSettingsComponent, } from '@components/ui-forms/deployment/ui-nuget-deployment-settings.component';
import { UiSettingForm } from '@components/ui-forms/ui-setting-form';
import { NugetType } from '@models';
import { takeUntil } from 'rxjs/operators';
var UiDeploymentSettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiDeploymentSettingsComponent, _super);
    function UiDeploymentSettingsComponent(_fb, cd, appState) {
        var _this = _super.call(this, cd, appState) || this;
        _this._fb = _fb;
        _this.NugetType = NugetType;
        return _this;
    }
    Object.defineProperty(UiDeploymentSettingsComponent.prototype, "isInitialized", {
        get: function () {
            return this._nugetDeploymentSettingsList.toArray().reduce(function (acc, component) { return acc && component.isInitialized; }, true);
        },
        enumerable: true,
        configurable: true
    });
    UiDeploymentSettingsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var componentsList = this._nugetDeploymentSettingsList.toArray();
        this.formGroup = this._fb.array(componentsList.map(function (comp) { return comp.formGroup; }));
        componentsList.forEach(function (component) {
            component.formChanges$
                .subscribe(function (formUpdate) { return _this._updateSettings(component.nugetType, formUpdate); });
        });
        this.isReadOnly$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (isReadOnly) { return isReadOnly ?
            _this.formGroup.disable() :
            _this.formGroup.enable(); });
    };
    UiDeploymentSettingsComponent.prototype._updateSettings = function (nugetType, formUpdate) {
        var authenticationTypes = formUpdate.authenticationTypes, payload = tslib_1.__rest(formUpdate, ["authenticationTypes"]);
        if (authenticationTypes) {
            Object.keys(authenticationTypes)
                .forEach(function (authenticationType) {
                Object.assign(payload, authenticationTypes[authenticationType]);
            });
        }
        Object.assign(this.settings.deployment[nugetType], payload);
    };
    return UiDeploymentSettingsComponent;
}(UiSettingForm));
export { UiDeploymentSettingsComponent };
